import { render, staticRenderFns } from "./AllForOne.vue?vue&type=template&id=630eb89b&"
import script from "./AllForOne.vue?vue&type=script&lang=js&"
export * from "./AllForOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports